import { createUserModule } from '@izimi/modules';

import { userApi } from '../di';

export const userModule = createUserModule({ userApi });
